import { ClickCollectDependenciesFactory } from "./dependencies.factory";

export const clickCollectEpicDependencies = {
    clickCollectService: ClickCollectDependenciesFactory.getClickCollectService()
}